import { render, staticRenderFns } from "./not-authorized.vue?vue&type=template&id=da893e66"
import script from "./not-authorized.vue?vue&type=script&lang=js"
export * from "./not-authorized.vue?vue&type=script&lang=js"
import style0 from "./not-authorized.vue?vue&type=style&index=0&id=da893e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports